
<ngx-spinner name="applicationSpinner" type="ball-atom" size="medium" color="#7cae15" [zIndex]="750000">
    <p style="font-size: 1.25rem; color: white">{{loadingText}}</p>
</ngx-spinner>
